import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: ${variables.sectionPadding};

    .headline {
        font-size: 1.7em;
        font-weight: 400;
        text-align: center;
    }

    .subheadline {
        font-size: 1.2em;
        color: #B29051;
        text-align: center;
        margin-bottom: 2em;
    }

    .public-layout-sections-blocks-description {
        .description {
            .device-description {
                display: flex;
                flex-direction: column;
                gap: 1em;

                .description {
                    margin: 0 0 1em 0;
                }

                .title {
                    font-size: 1.1em;
                    font-weight: 700;
                }

                .list {
                    display: flex;
                    flex-direction: column;
                    gap: 1em;

                    .list-item {
                        position: relative;
                        padding: 0 0 0 2em;

                        &:after {
                            position: absolute;
                            content: '';
                            left: 8px;
                            top: 7px;
                            width: 8px;
                            height: 8px;
                            border-radius: 8px;
                            background-color: #B29051;
                        }

                        b {
                            color: #B29051;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPaddingMobile};
    }
`;
